import {
  NotificationType,
  Public,
  Subject
} from '../types';
import {
  ConfirmationModal,
  ConfirmationModalProps,
  NotificationMessage
} from '../page-components';
import { PropsWithChildren } from 'react';

export type IGlobalModalsService = Public<GlobalModalsService>;

/** Stores the state of global modals that are rendered by the @see GlobalModals component. */
export class GlobalModalsService {
  activeDialogSubject = new Subject<JSX.Element | null>();
  private _dialogs: (JSX.Element | null)[] = [];

  get activeDialog(): JSX.Element | null {
    if (!this._dialogs.length) {
      return null;
    }
    return this._dialogs[this._dialogs.length - 1];
  }
  set activeDialog(newActiveDialog: JSX.Element | null) {
    if (newActiveDialog) {
      this._dialogs.push(newActiveDialog);
    } else {
      this._dialogs.pop();
    }
    this.activeDialogSubject.next(this.activeDialog);
  }

  openConfirmationModal(
    props: Omit<ConfirmationModalProps, 'isOpen' | 'onComplete'> = {}
  ): Promise<boolean> {
    return new Promise((resolve) => {
      this.activeDialog = (
        <ConfirmationModal
          {...props}
          onComplete={(proceed) => {
            resolve(proceed);
            this.activeDialog = null;
          }}
        />
      );
    });
  }

  async openNotificationModal(
    {
      children = null,
      header,
      type
    }: PropsWithChildren<{
      header: string;
      type: NotificationType;
    }>
  ): Promise<void> {
    await this.openConfirmationModal({
      children,
      hideContinue: true,
      labels: {
        cancelButton: 'Close',
        header: (
          <NotificationMessage
            children={header}
            type={type}
          />
        )
      }
    });
  }
}
